import {
  KineticNumberOptions,
  useKineticNumber,
} from './use-kinetic-number.hook';

export type KineticNumberDisplayProps = KineticNumberOptions & {
  value: number;
  /** Format the rendered number. */
  format?: (value: number) => string;
};

/**
 * Physics-based number transitioner.
 *
 * Uses a spring simulation instead of fixed A->B tweening.
 * If the target changes mid-animation, motion continues naturally.
 */
export const KineticNumberDisplay = ({
  value,
  format = (v) => v.toFixed(0),
  ...options
}: KineticNumberDisplayProps) => {
  const displayValue = useKineticNumber(value, options);

  return <>{format(displayValue)}</>;
};
